import React from 'react';
import { COPY } from './copy';

// "Request Additional Information" action on the specialist Consultation
// Report form. Uses the shared btn-red (draft-red) treatment so its hover
// matches the other action buttons — the old hardcoded #EB5757 "alert-red"
// was a stray duplicate the design system collapses into draft-red (SC-28401).
const OpenRequestButton = ({ onClick, disabled = false }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="btn btn-red"
  >
    {COPY.buttons.openRequest}
  </button>
);

export default OpenRequestButton;
